export default __webpack_public_path__ + "static/media/defaultFlag.8f68bfff.jpg";